import { useState, useCallback } from 'react';
import { Cliente, RespostaApiCliente, ErroApi } from '../types/gerArquivos';
import { GerArquivosService } from '../services/gerArquivosService';

interface UseClientesOptions {
  /** Inclui clientes roteados de outros tenants (catálogo cross-tenant). */
  includeRouted?: boolean;
}

interface UseClientesReturn {
  clientes: Cliente[];
  carregando: boolean;
  erro: ErroApi | null;
  buscarClientes: (termo: string) => Promise<void>;
  limparBusca: () => void;
}

export function useClientes(options?: UseClientesOptions): UseClientesReturn {
  const [clientes, setClientes] = useState<Cliente[]>([]);
  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState<ErroApi | null>(null);

  const includeRouted = options?.includeRouted ?? false;

  const buscarClientes = useCallback(async (termo: string) => {
    if (!termo.trim()) {
      setClientes([]);
      return;
    }

    setCarregando(true);
    setErro(null);

    try {
      const response = await GerArquivosService.buscarClientes(termo, {
        includeRouted,
      });

      if (response.success) {
        setClientes(response.data);
      } else {
        setErro({
          codigo: 'ERRO_BUSCA_CLIENTES',
          mensagem: response.error || 'Erro ao buscar clientes'
        });
      }
    } catch (error) {
      setErro({
        codigo: 'ERRO_REDE',
        mensagem: 'Erro de conexão com o servidor',
        detalhes: error instanceof Error ? error.message : 'Erro desconhecido'
      });
    } finally {
      setCarregando(false);
    }
  }, [includeRouted]);

  const limparBusca = useCallback(() => {
    setClientes([]);
    setErro(null);
  }, []);

  return {
    clientes,
    carregando,
    erro,
    buscarClientes,
    limparBusca
  };
}
